import {
    authorizationServicesPath,
} from "../../Constants";
import axios from "axios";

const restUrl = authorizationServicesPath + '/customers/customer-user-entity-roles'

export default class CustomerUserRolesServices {

    static async getAll(id) {
        return axios.get(restUrl + "/" + id + "/by-customer-user-entity");
    }

    static async edit(id, status, roleId) {
        return axios.patch(restUrl + "/" + id + "/by-customer-user-entity" + "?status=" + status + "&roleId=" + roleId, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}